import React from 'react';
import { ContainerSm, Content, Title, Value } from './styles';
import { Grid, CircularProgress } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';

interface InfoCardNewProps {
  title: string;
  value: string | false | null;
  color?: string;
}

function InfoCardNew({ title, value, color = 'blue' }: InfoCardNewProps) {
  const isSmDevice = useMediaQuery('(max-width:959px)');

  if (isSmDevice) {
    return (
      <ContainerSm>
        <Title>{title}</Title>
        <Value color={color}>{value}</Value>
      </ContainerSm>
    )
  }

  return (
    <Grid item xs={12} md={6} lg={3} style={{paddingLeft: '0', paddingRight: '16px'}}>
      <Content
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Title>{title}</Title>
        {value ? (
          <Value color={color}>{value}</Value>
        ) : (
          <CircularProgress />
        )}
      </Content>
    </Grid>
  )
}

export default InfoCardNew;
